import { createAction, props } from '@ngrx/store';
import { FlightAvailabilityToCheckinState } from './flight-availability-to-checkin.state';

/** StateDetailsActions */
const ACTION_SET = '[FlightAvailabilityToCheckin] set';
const ACTION_UPDATE = '[FlightAvailabilityToCheckin] update';
const ACTION_RESET = '[FlightAvailabilityToCheckin] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setFlightAvailabilityToCheckin = createAction(ACTION_SET, props<FlightAvailabilityToCheckinState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateFlightAvailabilityToCheckin = createAction(
  ACTION_UPDATE,
  props<Partial<FlightAvailabilityToCheckinState>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetFlightAvailabilityToCheckin = createAction(ACTION_RESET);
